App.filter('removeunderscores', function () {
  return function (input) {
    return input.replace(/_/g, ' ')
  }
});
